export var TOOLBAR_ACTION_SUBJECT_ID = /*#__PURE__*/function (TOOLBAR_ACTION_SUBJECT_ID) {
  TOOLBAR_ACTION_SUBJECT_ID["FIND_REPLACE"] = "findReplace";
  TOOLBAR_ACTION_SUBJECT_ID["EMOJI"] = "emoji";
  TOOLBAR_ACTION_SUBJECT_ID["ORDERED_LIST"] = "orderedList";
  TOOLBAR_ACTION_SUBJECT_ID["BULLET_LIST"] = "bulletList";
  TOOLBAR_ACTION_SUBJECT_ID["MEDIA"] = "media";
  TOOLBAR_ACTION_SUBJECT_ID["MENTION"] = "mention";
  TOOLBAR_ACTION_SUBJECT_ID["DECISION_LIST"] = "decisionList";
  TOOLBAR_ACTION_SUBJECT_ID["TASK_LIST"] = "taskList";
  TOOLBAR_ACTION_SUBJECT_ID["TEXT_COLOR"] = "color";
  TOOLBAR_ACTION_SUBJECT_ID["BACKGROUND_COLOR"] = "backgroundColor";
  TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_STRONG"] = "strong";
  TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_ITALIC"] = "italic";
  TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_UNDERLINE"] = "underline";
  TOOLBAR_ACTION_SUBJECT_ID["UNDO"] = "undo";
  TOOLBAR_ACTION_SUBJECT_ID["REDO"] = "redo";
  TOOLBAR_ACTION_SUBJECT_ID["INDENT"] = "indent";
  TOOLBAR_ACTION_SUBJECT_ID["OUTDENT"] = "outdent";
  TOOLBAR_ACTION_SUBJECT_ID["RECORD_VIDEO"] = "recordVideo";
  TOOLBAR_ACTION_SUBJECT_ID["AI"] = "atlassian-intelligence";
  return TOOLBAR_ACTION_SUBJECT_ID;
}({});